export const Dashboard = () => {
  return <div>DASHBOARD</div>;
};
